import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import FlexGrow from './FlexGrow';
import ClientProvider from './client';
export default createDemo(import.meta.url, FlexGrow, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/system/flexbox/demos/flex-grow/FlexGrow.tsx",
    "fileName": "FlexGrow.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import Box from '@mui/material/Box';\nimport type { BoxProps } from '@mui/material/Box';\n\nfunction Item(props: BoxProps) {\n  const { sx = [], ...other } = props;\n  return (\n    <Box\n      sx={[\n        (theme) => ({\n          p: 1,\n          m: 1,\n          bgcolor: 'grey.100',\n          color: 'grey.800',\n          border: '1px solid',\n          borderColor: 'grey.300',\n          borderRadius: 2,\n          fontSize: '0.875rem',\n          fontWeight: '700',\n          ...theme.applyStyles('dark', {\n            bgcolor: '#101010',\n            color: 'grey.300',\n            borderColor: 'grey.800',\n          }),\n        }),\n        ...[sx].flat(),\n      ]}\n      {...other}\n    />\n  );\n}\n\nexport default function FlexGrow() {\n  return (\n    <div style={{ width: '100%' }}>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 3,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <Box\n        sx={{ display: 'flex', p: 1, bgcolor: 'background.paper', borderRadius: 1 }}\n      >\n        <Item sx={{ flexGrow: 1 }}>Item 1</Item>\n        <Item>Item 2</Item>\n        <Item>Item 3</Item>\n      </Box>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </div>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 44,
        "focusedLines": 7,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import Box from '@mui/material/Box';\nimport type { BoxProps } from '@mui/material/Box';\n\nfunction Item(props: BoxProps) {\n  const { sx = [], ...other } = props;\n  return (\n    <Box\n      sx={[\n        (theme) => ({\n          p: 1,\n          m: 1,\n          bgcolor: 'grey.100',\n          color: 'grey.800',\n          border: '1px solid',\n          borderColor: 'grey.300',\n          borderRadius: 2,\n          fontSize: '0.875rem',\n          fontWeight: '700',\n          ...theme.applyStyles('dark', {\n            bgcolor: '#101010',\n            color: 'grey.300',\n            borderColor: 'grey.800',\n          }),\n        }),\n        ...[sx].flat(),\n      ]}\n      {...other}\n    />\n  );\n}\n\nexport default function FlexGrow() {\n  return (\n    <div style={{ width: '100%' }}>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        "      <Box\n        sx={{ display: 'flex', p: 1, bgcolor: 'background.paper', borderRadius: 1 }}\n      >\n        <Item sx={{ flexGrow: 1 }}>Item 1</Item>\n        <Item>Item 2</Item>\n        <Item>Item 3</Item>\n      </Box>\n"
      ],
      [
        "span",
        "frame",
        "    </div>\n  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 35
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Box"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 36
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "sx"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "{ ",
              [
                "span",
                "di-op di-jv",
                "display"
              ],
              ": ",
              [
                "span",
                "pl-s",
                [
                  [
                    "span",
                    "pl-pds",
                    "'"
                  ],
                  "flex",
                  [
                    "span",
                    "pl-pds",
                    "'"
                  ]
                ]
              ],
              ", ",
              [
                "span",
                "di-op di-jv",
                "p"
              ],
              ": ",
              [
                "span",
                "pl-c1 di-num",
                "1"
              ],
              ", ",
              [
                "span",
                "di-op di-jv",
                "bgcolor"
              ],
              ": ",
              [
                "span",
                "pl-s",
                [
                  [
                    "span",
                    "pl-pds",
                    "'"
                  ],
                  "background.paper",
                  [
                    "span",
                    "pl-pds",
                    "'"
                  ]
                ]
              ],
              ", ",
              [
                "span",
                "di-op di-jv",
                "borderRadius"
              ],
              ": ",
              [
                "span",
                "pl-c1 di-num",
                "1"
              ],
              " }",
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 37
            },
            "      >"
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 38
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "Item"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "sx"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "{ ",
              [
                "span",
                "di-op di-jv",
                "flexGrow"
              ],
              ": ",
              [
                "span",
                "pl-c1 di-num",
                "1"
              ],
              " }",
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">Item 1</",
              [
                "span",
                "pl-c1 di-jsx",
                "Item"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 39
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "Item"
              ],
              ">Item 2</",
              [
                "span",
                "pl-c1 di-jsx",
                "Item"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 40
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "Item"
              ],
              ">Item 3</",
              [
                "span",
                "pl-c1 di-jsx",
                "Item"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 41
            },
            [
              "      </",
              [
                "span",
                "pl-c1 di-jsx",
                "Box"
              ],
              ">"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 44,
    "focusedLines": 7,
    "collapsible": true,
    "externals": [
      "@mui/material/Box"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
